module.exports = __webpack_public_path__ + "static/media/index.e91ce408.svg";